import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function Customer (props){

    return <BasicCrudScreenType id="Customer" table="Customer" view="Customer" />;
}
export default Customer;